import { render, staticRenderFns } from "./AvatarBadge.vue?vue&type=template&id=9c55fda6&"
import script from "./AvatarBadge.vue?vue&type=script&lang=js&"
export * from "./AvatarBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports